<template>
  <form class="needs-validation ml-0" novalidate @submit.prevent="handleSubmit">
    <div class="col px-0 pr-lg-3">
      <div class="bg-white rounded mb-4 p-3">
        <page-heading>Create Draft</page-heading>

        <draft-details-section
          :value="form"
          :edit="false"
          :available-drafts="draftOptions"
          :loading-drafts="loadingDrafts"
          :states="draftStates"
          :loading-states="loadingStates"
          :errors="errors"
          @input="updateForm"
        />
        <draft-rules-section :value="form" :errors="errors" @input="updateForm" />
        <medical-services-section :value="form" :errors="errors" @input="updateForm" />
        <payment-details-section :value="form" :errors="errors" :is-stripe-verified="isStripeVerified" @input="updateForm" />

        <mobile-submit-button :loading="submitting" :no-bottom="true">
          Create
        </mobile-submit-button>
      </div>
    </div>

    <desktop-action-bar>
      <app-button type="submit" class="px-md-5" :loading="submitting">
        Create
      </app-button>
    </desktop-action-bar>
  </form>
</template>

<script>
import { defineComponent, reactive, computed, watch, getCurrentInstance } from '@vue/composition-api'
import EventBus from '@/store/EventBus'
import useAvailableDrafts from '@/composables/drafts/useAvailableDrafts'
import useDraftStates from '@/composables/drafts/useDraftStates'
import useDraftForm, { defaultDraftForm } from '@/composables/drafts/useDraftForm'
import useCurrentUser from '@/composables/useCurrentUser'
import PageHeading from '@/components/PageHeading'
import AppButton from '@/components/AppButton'
import DesktopActionBar from '@/components/DesktopActionBar'
import MobileSubmitButton from '@/components/MobileSubmitButton'
import DraftDetailsSection from '@/components/Drafts/DraftDetailsSection'
import DraftRulesSection from '@/components/Drafts/DraftRulesSection'
import MedicalServicesSection from '@/components/Drafts/MedicalServicesSection'
import PaymentDetailsSection from '@/components/Drafts/PaymentDetailsSection'


export default defineComponent({
  name: 'SecretaryDraftDetails',
  components: {
    PageHeading,
    DraftDetailsSection,
    DraftRulesSection,
    MedicalServicesSection,
    PaymentDetailsSection,
    AppButton,
    DesktopActionBar,
    MobileSubmitButton
  },
  setup() {
    const { proxy } = getCurrentInstance()
    const form = reactive(defaultDraftForm())
    const { options: draftOptions, loading: loadingDrafts } = useAvailableDrafts()
    const { states: draftStates, loading: loadingStates } = useDraftStates()
    const { errors, submitting, submit } = useDraftForm(form)
    const { user: currentUser } = useCurrentUser()

    const isStripeVerified = computed(() => {
      const selected = draftOptions.value.find(o => o.id === form.draft_id)
      return selected != null ? !!selected.is_stripe_verified : false
    })

    watch(draftStates, (states) => {
      if (states.length > 0 && form.draft_state_id == null) {
        form.draft_state_id = states[0].id
      }
    })

    watch(currentUser, (me) => {
      // CAM-1533: working for another committee — the contact is not the logged-in user, leave empty
      if (!me || proxy.$isActingForOtherCommittee) return
      if (!form.secretary_contact_name) {
        form.secretary_contact_name = `${me.first_name} ${me.last_name}`
      }
      if (!form.secretary_phone_number) {
        form.secretary_phone_number = me.phone != null ? me.phone : me.mobile_phone
      }
    })

    function updateForm(updated) {
      Object.assign(form, updated)
    }

    async function handleSubmit() {
      const result = await submit()
      if (result) {
        const successMsg = typeof result.message === 'string' ? result.message : 'Draft created successfully'
        proxy.$router.push({ name: 'Event Create', params: { id: String(result.id) } }, () => {
          proxy.$nextTick(() => {
            EventBus.$emit('show-success', successMsg)
          })
        })
      }
    }

    return {
      form,
      updateForm,
      draftOptions,
      loadingDrafts,
      isStripeVerified,
      draftStates,
      loadingStates,
      errors,
      submitting,
      handleSubmit
    }
  }
})
</script>




// WEBPACK FOOTER //
// src/views/Drafts/Add/SecretaryDraftDetails.vue